import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { HttpClientModule } from '@angular/common/http';
import { Routes, RouterModule } from '@angular/router';
import { GoogleMapsModule } from '@angular/google-maps';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './nav/header/header.component';
import { UserLoginComponent } from './auth/user-login/user-login.component';
import { FooterComponent } from './nav/footer/footer.component';
import { environment } from 'src/environments/environment';
import { SafeHtmlPipe, TestListComponent } from './tests/test-list/test-list.component';

import * as bootstrap from 'bootstrap';
import * as $ from 'jquery';
import { FilterPipe } from './shared/filter.pipe';
import { TestDetailComponent } from './tests/test-detail/test-detail.component';
import { SupportComponent } from './support/support.component';
import { ProfileComponent } from './profile/profile.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { UserRegisterComponent } from './auth/user-register/user-register.component';
import { UserManagementComponent } from './admin/user-management/user-management.component';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { LocationDropdownComponent } from './location-dropdown/location-dropdown.component';
import { WaterSourceDropdownComponent } from './water-source-dropdown/water-source-dropdown.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { LocationListComponent } from './location-list/location-list.component';
import { TestDetailsCardComponent } from './test-details-card/test-details-card.component';
import { LocationDetailComponent } from './location-detail/location-detail.component';
import { OrgManagementComponent } from './admin/org-management/org-management.component';
import { OrgDetailsComponent } from './admin/org-management/org-details/org-details.component';
import { UserDetailsComponent } from './admin/user-management/user-details/user-details.component';
import { MatMenuModule } from '@angular/material/menu';
import { EmailTemplateComponent } from './email-template/email-template.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ApiReferenceComponent } from './support/api-reference/api-reference.component';
import { UserDropdownComponent } from './user-dropdown/user-dropdown.component';
import { GeotagModalComponent } from './geotag-modal/geotag-modal.component';
import { ApiKeyComponent } from './api-key/api-key.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import {MatCardModule} from "@angular/material/card";
import {SharedModule} from "./shared/shared.module";


const appRoutes: Routes = [
  {path: '', pathMatch: 'full', component: UserLoginComponent},
  {path: 'user-management', component: UserManagementComponent},
  {path: 'user/:id', component: UserDetailsComponent},
  {path: 'user/', pathMatch: 'full', redirectTo: '/user-management'},
  {path: 'reset-password', component: ResetPasswordComponent},
  {path: 'register', component: UserRegisterComponent},
  {path: 'profile', component: ProfileComponent},
  {path: 'support', component: SupportComponent},
  {path: 'tests', component: TestListComponent, data: {displayMap: false}},
  {path: 'map-view', component: TestListComponent, data: {displayMap: true}},
  {path: 'test/:id', component: TestDetailComponent},
  {path: 'location/:id', component: LocationDetailComponent},
  {path: 'location', redirectTo: '/locations', pathMatch: 'full'},
  {path: 'organization/:id', component: OrgDetailsComponent},
  {path: 'organization', redirectTo: '/organizations', pathMatch: 'full'},
  {path: 'locations', component: LocationListComponent},
  {path: 'api/reference', component: ApiReferenceComponent},
  {path: 'organizations', component: OrgManagementComponent},
  {path: 'api-keys', component: ApiKeyComponent}
];

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    UserLoginComponent,
    FooterComponent,
    TestListComponent,
    FilterPipe,
    TestDetailComponent,
    SupportComponent,
    ProfileComponent,
    UserRegisterComponent,
    UserManagementComponent,
    ResetPasswordComponent,
    LocationDropdownComponent,
    WaterSourceDropdownComponent,
    SafeHtmlPipe,
    LocationListComponent,
    TestDetailsCardComponent,
    LocationDetailComponent,
    OrgManagementComponent,
    OrgDetailsComponent,
    UserDetailsComponent,
    EmailTemplateComponent,
    ApiReferenceComponent,
    UserDropdownComponent,
    GeotagModalComponent,
    ApiKeyComponent
  ],
  imports: [
    MDBBootstrapModule.forRoot(),
    GooglePlaceModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes),
    BrowserAnimationsModule,
    NgbModule,
    HttpClientModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxSkeletonLoaderModule,
    MatSidenavModule,
    MatTabsModule,
    GoogleMapsModule,
    MatMenuModule,
    InfiniteScrollModule,
    MatPaginatorModule,
    MatCardModule,
    SharedModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {


}
